import React from 'react'

const NoPage = () => {
  return (
    <div>Are You Lost Baby Girl ???</div>
  )
}

export default NoPage